import type { ListBuilderList } from '../../../types';
import { createShopRecentlyRestockedColumns } from '../columns';
import {
	SHOP_MOBILE_CARD_CONFIG,
	SHOP_RECENTLY_RESTOCKED_REQUIRED_FIELDS,
} from '../shared';

/**
 * Shop Recently Restocked list configuration
 * Items whose available qty transitioned <= 0 → > 0 within the last 30 days.
 */
export const shopRecentlyRestockedList: ListBuilderList = {
	id: 'shop_recently_restocked',
	cacheTTL: 600000,
	name: 'Recently Restocked',
	type: 'default',
	active: true,
	sortOrder: 7,
	columns: createShopRecentlyRestockedColumns(),
	description: 'Items recently out of stock that are now available again',
	defaultSortId: 'column-restocked_date-desc',
	requiredFields: SHOP_RECENTLY_RESTOCKED_REQUIRED_FIELDS,
	mobileCardConfig: SHOP_MOBILE_CARD_CONFIG,
	filterRules: {
		item_filters: {
			defaultValue: [
				{
					id: 'recently_restocked',
					label: 'Recently Restocked',
				},
			],
		},
	},
};
